<div class="status-bar-colored-bottom"></div>
<div *ngIf="hymn">
  <mat-toolbar color="primary" class="sticky-toolbar-router">
    @if (!sidenavService.hymnListOpen) {
      <div class="padding-safe-left"></div>
    }

    <button *ngIf="!continuousPlaybackService.active" (click)="toggleListSidenav()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>

    <button *ngIf="continuousPlaybackService.active" mat-icon-button [matMenuTriggerFor]="lockMenu">
      <mat-icon>lock</mat-icon>
    </button>

    <mat-menu #lockMenu="matMenu">
      <button (click)="continuousPlaybackService.stopContinuousPlayback()" mat-menu-item>
        <mat-icon>playlist_remove</mat-icon>
        <span>{{translation.stop_automatic_playback}}</span>
      </button>
    </mat-menu>

    <span [matMenuTriggerFor]="hymnInfoMenu" class="title-ellipsis" *ngIf="hymn">{{translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title}}</span>

    <mat-menu #hymnInfoMenu="matMenu">
      <button mat-menu-item>
        <span>{{translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title}}</span>
      </button>
    </mat-menu>

    <span class="toolbar-fill-remaining-space"></span>

    <button *ngIf="settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" (click)="settingService.removeHymnFromFavoritesAndToLearn(hymn);" mat-icon-button>
      <mat-icon *ngIf="settingService.isFavorite(hymn.hymnNumber)">favorite</mat-icon>
      <mat-icon *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">bookmark</mat-icon>
    </button>

    <button *ngIf="!settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" [matMenuTriggerFor]="favoriteMenu" mat-icon-button>
      <mat-icon>favorite_border</mat-icon>
    </button>

    <mat-menu #favoriteMenu="matMenu">
      <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
        <mat-icon>favorite_border</mat-icon>
        <span>{{translation.add_to_favorites}}</span>
      </button>
      <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
        <mat-icon>bookmark_border</mat-icon>
        <span>{{translation.add_to_hymns_to_learn}}</span>
      </button>
    </mat-menu>

    <button *ngIf="!continuousPlaybackService.active" mat-icon-button (click)="hymnSelectionService.dialpad()">
      <mat-icon>dialpad</mat-icon>
    </button>

    <button *ngIf="!continuousPlaybackService.active" mat-icon-button [matMenuTriggerFor]="shuffleMenu">
      <mat-icon>shuffle</mat-icon>
    </button>

    <mat-menu #shuffleMenu="matMenu">
      <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
        <mat-icon>shuffle</mat-icon>
        <span>{{translation.random_favorite}}</span>
      </button>
      <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
        <mat-icon>shuffle</mat-icon>
        <span>{{translation.random_hymn}}</span>
      </button>
    </mat-menu>

    <button mat-icon-button [matMenuTriggerFor]="presentMenu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #presentMenu="matMenu">

      <button *ngIf="!continuousPlaybackService.active" (click)="settingService.setPresentationViewMode()" [routerLink]="['/'+translation.path_present, hymn.hymnNumber]" mat-menu-item>
        <mat-icon>tv</mat-icon>
        <span>{{translation.presentation_mode}}</span>
      </button>

      <button *ngIf="layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareHymn(this.hymn)">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_hymn + " " + hymn.hymnNumber}}</span>
      </button>

      <button mat-menu-item *ngIf="layoutService.fullscreenSupported()" (click)="layoutService.toggleFullScreen()">
        <mat-icon *ngIf="!layoutService.fullscreen">fullscreen</mat-icon>
        <mat-icon *ngIf="layoutService.fullscreen">fullscreen_exit</mat-icon>
        <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
      </button>

      <button (click)="changeFontSize()" mat-menu-item>
        <mat-icon>text_fields</mat-icon>
        <span>{{translation.change_font_size}}</span>
      </button>

      <button *ngIf="!layoutService.singleView" mat-menu-item (click)="modalService.openDialog('shortcuts')">
        <mat-icon>keyboard_command_key</mat-icon>
        <span>{{translation.shortcuts}}</span>
      </button>

      <button (click)="toggleSettingSidenav()" mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>{{translation.settings}}</span>
      </button>

      <button mat-menu-item (click)="shareService.suggestCorrection(this.hymn)">
        <mat-icon>create</mat-icon>
        <span>{{translation.suggest_correction}}</span>
      </button>

      <button *ngIf="!layoutService.singleView && layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareApp();">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_app}}</span>
      </button>
    </mat-menu>

    @if (!settingService.settingsOpened) {
      <div class="padding-safe-right"></div>
    }
  </mat-toolbar>

  <div class="scroll-wrapper" #scrollWrapper doubletap (doubletap)="onDoubleTap()" swipeGesture [axis]="'x'" (swipeleft)="onSwipeNext()" (swiperight)="onSwipePrevious()" >

    <div id="content-container" #content_container class="padded-container tab-container text-stroked" [style.font-family]="readFontFamily || null" [style.font-weight]="readFontWeight || null">
      <div *ngIf="hymn" class="bootstrap-container">
        <mat-card class="hymnTitle mat-card-main">
          <mat-card-header>
            <span [style.font-size]="fontSizeStyle">{{hymn.title}}</span>
          </mat-card-header>
          <mat-card-content></mat-card-content>
        </mat-card>

        <ng-container *ngIf="hymn.startsWithChorus">
          <mat-card class="verse-card mat-card-main">
            <mat-card-header style="margin-bottom: 8px;" #headerChorus [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle">
              <i style="text-decoration: underline">{{translation.refrain}}</i> <span *ngIf="midiService.playing && midiService.playingChorus && midiService.currentVerse == 0" [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle" class="material-icons-outlined">music_note</span>
            </mat-card-header>
            <mat-card-content #chorus [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle">
              <p class="verse-line" *ngFor="let line of Hymn.getChorus(hymn, 1)">{{ line }}</p>
            </mat-card-content>
          </mat-card>
        </ng-container>

        <ng-container *ngFor="let verse of hymn.verses;">
          <mat-card class="verse-card mat-card-main">
            <mat-card-header style="margin-bottom: 8px;" #headerContent [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle">
              <i style="text-decoration: underline">{{translation.verse + " " + verse.verseNumber}}</i> <span *ngIf="midiService.playing && !midiService.playingChorus && midiService.currentVerse == +verse.verseNumber" [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle" class="material-icons-outlined">music_note</span>
            </mat-card-header>
            <mat-card-content #content [style.font-size]="fontSizeStyle" style="line-height: 1em;">
              <p class="verse-line" *ngFor="let line of verse.content">{{ line }}</p>
            </mat-card-content>
          </mat-card>

          <ng-container *ngIf="hymn.hasChorus">
            <mat-card class="verse-card mat-card-main">
              <mat-card-header style="margin-bottom: 8px;" #headerChorus [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle">
                <i style="text-decoration: underline">{{translation.refrain}}</i> <span *ngIf="midiService.playing && midiService.playingChorus && midiService.currentVerse == +verse.verseNumber" [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle" class="material-icons-outlined">music_note</span>
              </mat-card-header>
              <mat-card-content #chorus [style.font-size]="fontSizeStyle" [style.line-height]="lineHeightStyle">
                <p class="verse-line" *ngFor="let line of Hymn.getChorus(hymn, verse.verseNumber)">{{ line }}</p>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>

        <div style="height: 100px;"></div>
      </div>
    </div>
  </div>

  <app-music-control class="music-control-menu"></app-music-control>
</div>
